import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';
import { DropdownMenu } from 'ui-components/components/dropdown-menu';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';
import { Gap } from 'ui-components/components/flex/gap';
import { FlexRow } from 'ui-components/components/flex/row';
import { THEME_CONSTANTS } from 'ui-components/services/button-theme-service';

import messages from '../../../../../messages';
import DownloadSample from '../../../../download-sample';

/**
 * @typedef {object} Template
 * @property {string} [packingSlipId]
 * @property {string} name
 * @property {string} header
 * @property {string} itemsHeader
 * @property {string} items
 * @property {string} footer
 * @property {string} size
 * @property {boolean} [shared]
 */

/**
 * @param {object} props
 * @param {() => void} props.onCancel
 * @param {() => void} props.onSaveClicked
 * @param {Template} props.template
 * @returns {JSX.Element}
 */
export const EditorModalFooter = ({ onCancel, onSaveClicked, template }) => {
  return (
    <>
      <DropdownMenu>
        <DropdownMenuToggler theme={THEME_CONSTANTS.link}>
          <FormattedMessage {...messages.downloadSample} />
        </DropdownMenuToggler>
        <DownloadSample>
          {({ stores, onDownloadClick }) => {
            return stores.map(({ storeGuid, name }) => {
              return (
                <DropdownMenuItem key={storeGuid} onClick={() => onDownloadClick(storeGuid, template)}>
                  {name}
                </DropdownMenuItem>
              );
            });
          }}
        </DownloadSample>
      </DropdownMenu>
      <FlexRow gap={Gap.Space4}>
        <Button onClick={onCancel} theme={THEME_CONSTANTS.tertiary}>
          <FormattedMessage {...messages.cancel} />
        </Button>
        <Button onClick={onSaveClicked} testId='editor-save-button' theme={THEME_CONSTANTS.primary}>
          <FormattedMessage {...messages.save} />
        </Button>
      </FlexRow>
    </>
  );
};
